---
title: "The hidden cost of ignoring your frontend after going backend"
date: "2025-05"
description: "What happens to your product intuition when you stop shipping UI for two years — and how to get it back."
---

# The hidden cost of ignoring your frontend after going backend

Two years ago I moved into a backend-heavy role. API design, infrastructure, data pipelines — I loved it. But I quietly stopped shipping UI. No design reviews, no user feedback sessions, no "does this actually feel right?" moments.

What I didn't expect: that gap compounds. Fast.

## What you lose without noticing

Product intuition isn't a skill you study — it's a muscle you build by shipping things and watching people use them. When you stop doing that, you don't *feel* it eroding. You just notice, six months later, that your instincts about "is this interaction confusing?" have gone blurry.

I started second-guessing small things. Should this be one step or two? Where does the error state live? Is this form too long? I used to answer those in seconds.

## Getting it back

The fastest path back wasn't side projects — it was code review. Specifically, starting to care again about the components I was reviewing, not just the logic.

What does this state transition feel like to a user? Why did we put this behind two clicks? Questions like that, asked out loud in PRs, forced me back into the habit of thinking from the outside in.

---

*This is an example write-up to demonstrate the content system.*
